<div class="app-notification-options">
    <ion-list no-padding no-margin lines="none">
        <ion-item (click)="delete()">
            <ion-label>
                {{'notifications.delete' | translate}}
            </ion-label>
        </ion-item>
    </ion-list>
</div>